import React from "react";
import GoogleMapWrapper from "./GoogleMapWrapper";
import RacerMarker from "./RacerMarker";
import {database} from "../firebase";
import { KmlLayer } from "react-google-maps";

export default class Map extends React.Component {

    cleanupTime = 15 * 60 * 1000;

    constructor(props) {
        super(props);
        this.state = {
            racers: {},
            zoom: 2,
            center: {lat: 27, lng: 0},
        };
        this.mapDomRef = React.createRef();
    }

    componentDidMount() {
        //const refs = {}
        this.setState({
            onMapMounted: (ref) => {
                this.setState({
                    mapRef: ref,
                });
            },
        });


        this.cleanupTimer = setInterval(() => {
            console.log("cleanup");
            const thereshold = new Date().getTime() - this.cleanupTime;
            this.setState((prevState) => ({
                racers: Object.fromEntries(Object.entries(prevState.racers).filter(([key, value]) => value.timeStamp.timeStamp > thereshold)),
            }));
        }, 30000);

        const now = new Date()
        const fiveMinutes = 60 * 1000 * 5;
        const utcDateMillis = now.getTime() - fiveMinutes;
        const query = database.ref("tracking").orderByChild("timeStamp/timeStamp").startAt(utcDateMillis);
        query.on("child_added", (data) => {
            console.log("Child added");
            this.setState((prevState) => {
                return this.setMarker(data, prevState);
            });
        });

        query.on("child_changed", (data) => {
            console.log("Child changed");
            this.setState((prevState) => {
                return this.setMarker(data, prevState);
            });
        });


        query.on("child_removed", (data) => {
            console.log("Child removed");
            this.setState((prevState) => {
                return this.removeMarker(data, prevState);
            });
        });

    }

    centerToMarker(id, latlng) {
        this.unsubscribeFromMovements();

        if (this.state.mapRef.getZoom() < 14) {
            this.setState({zoom: 14});
        }
        this.setState({
            centered: true,
            center: latlng,
        });
        this.movementRef = database.ref("tracking/" + id);
        this.movementListener = this.movementRef.on("value", (data) => {
            let value = data.val();
            if (value != null) {
                this.setState({
                    center: {lat: value.lat, lng: value.lng},
                });
            }
        });
    }

    unsubscribeFromMovements() {
        if (!(this.movementRef === null || this.movementRef === undefined)) {
            this.movementRef.off("value", this.movementListener);
            this.movementRef = null;
        }
    }

    componentWillUnmount() {
        clearInterval(this.cleanupTimer);
        database.ref("tracking").off();
        this.unsubscribeFromMovements();
    }

    setMarker = (data, prevState) => {
        let racerState = prevState.racers;
        racerState[data.key] = data.val();
        return {racers: racerState}
    }

    removeMarker = (data, prevState) => {
        let racerState = prevState.racers;
        delete racerState[data.key];
        return {racers: racerState}
    }

    onMarkerClick = (id, latlng) => {
        this.props.onRacerChoice(id);
        this.centerToMarker(id, latlng);
    };

    onCenterChanged = () => {
        if (this.state.centered) {
            this.setState({
                centered: false,
            });
            this.unsubscribeFromMovements();
        }
    };

    onZoomChanged = () => {
        this.setState({zoom: this.state.mapRef.getZoom()});
    };

    render() {
        return (
            <GoogleMapWrapper
                onDrag={this.onCenterChanged}
                googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry&key=AIzaSyCvLBlfPLh5WzH9O8s2NIRltlLL1gTPHMk"
                loadingElement={<div style={{height: `100%`}}/>}
                containerElement={
                    <div
                        style={{
                            height: `100%`,
                            width: "100%",
                            margin: "0",
                            padding: "0",
                            position: "relative",
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0,
                        }}
                    />
                }
                mapElement={<div style={{height: `100%`}}/>}
                onMapMounted={this.state.onMapMounted}
                mapTypeId="hybrid"
                onZoomChanged={this.onZoomChanged}
                onBoundsChanged={this.onBoundsChanged}
                center={this.state.center}
                zoom={this.state.zoom}
            >

                {Object.entries(this.state.racers).map((racer) => {
                    let key = racer[0];
                    let value = racer[1];
                    return (
                        <RacerMarker
                            onMarkerClick={this.onMarkerClick}
                            key={key}
                            id={key}
                            uid={key}
                            data={value}
                        />
                    );
                })}
                <KmlLayer url = "https://firebasestorage.googleapis.com/v0/b/rally-266f6.appspot.com/o/kml%2FDrive%20Estonia.kmz?alt=media&token=f7f1eed9-cdb6-4fc2-9aca-d3d15765ce35" options={{preserveViewport: true}}></KmlLayer>
            </GoogleMapWrapper>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Map.js